var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2934_3693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.38477 7.53681C1.38477 5.86038 2.05073 4.25261 3.23614 3.06719C4.42156 1.88178 6.02932 1.21582 7.70575 1.21582C9.38218 1.21582 10.99 1.88178 12.1754 3.06719C13.3608 4.25261 14.0267 5.86038 14.0267 7.53681V11.5585C14.0267 12.2286 14.0267 12.562 13.9272 12.8298C13.848 13.0421 13.7242 13.2348 13.564 13.395C13.4038 13.5552 13.211 13.6791 12.9988 13.7582C12.7309 13.8578 12.3967 13.8578 11.7275 13.8578H7.70575C6.02932 13.8578 4.42156 13.1918 3.23614 12.0064C2.05073 10.821 1.38477 9.21324 1.38477 7.53681Z",
    stroke: "#344054",
    strokeWidth: 0.711111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33594 6.74731H10.0767M7.70631 9.90781H10.0767",
    stroke: "#344054",
    strokeWidth: 0.711111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2934_3693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.2222,
    height: 14.2222,
    fill: "white",
    transform: "translate(0.592773 0.426025)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.c69c38fd85b4d7174f639cae32acd4f5.svg";
export { ForwardRef as ReactComponent };